import { render, staticRenderFns } from "./TableGoals.vue?vue&type=template&id=545979d0&"
import script from "./TableGoals.vue?vue&type=script&lang=js&"
export * from "./TableGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports